// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__u90+V","shown":"Overlay_shown__HIDs7"};